import { IContentCard } from './IContentCard';
import { ILink } from './ILink';
import DisplayStyleEnum from './enums/DisplayStyleEnum';
import SiteEnum from './enums/SiteEnum';
import VariantTypeEnum from './enums/VariantTypeEnum';

export const enum ContendCardCtaPosition {
  Top = 'top',
  Bottom = 'bottom',
}
export interface IContentCards {
  readonly backgroundColour: string;
  readonly cardStyle: Exclude<VariantTypeEnum, VariantTypeEnum.Cta>;
  readonly cardType: 'article' | 'deco' | null;
  readonly cards: IContentCard[] | null;
  readonly decoBackgroundHexCode?: string;
  readonly cta: ILink;
  readonly displayAs: DisplayStyleEnum;
  readonly hideCardBackground: boolean;
  readonly hideCardCtas: boolean;
  readonly hideCardText: boolean;
  readonly hideImages: boolean;
  readonly itemsPerRow: 2 | 3 | 4;
  readonly portraitImages: boolean;
  readonly site: SiteEnum;
  readonly title?: string;
  readonly useSerifTitleFont: boolean;
}
